// extracted by mini-css-extract-plugin
export default {"container":"uz-z"};